<template>
  <div>
    <div id="hereMap" ref="map" class="map"></div>
  </div>
</template>

<script>
/* global CONFIG */
const request = require('browser-request')
import moment from 'moment-timezone'
import mapPins from '@/values/map-pin'
import featureToggle from '@/modules/api/featureToggle'
import ApiRsvpSearch from '@/modules/api/reservation-search'
import { clearTimeout } from 'timers'

export default {
  name: 'tracking-map2',
  data () {
    return {
      map: {},
      platform: {},
      router: {},
      geocoder: {},
      directions: [],
      ui: {},
      center: { lat: 33.942791, lng: -118.410042 },
      driverETA: null,
      driverTimer: '',
      routeResults: [],
      lastCoords: {
        origin: { lat: '', lng: '' },
        destination: { lat: '', lng: '' }
      },
      userPickedUp: false,
      asapDirectMapFix: false
    }
  },
  computed: {
    rsvp () { return this.$store.state.rsvpTrack.rsvp },
    eta () {
      let self = this
      let pickupTime = moment(self.rsvp.pickupTime, 'MM/DD/YYYY ' + featureToggle.timeFormat(self, false))
      return pickupTime.add(self.rsvp.eta, 'seconds').format('MM/DD/YYYY ' + featureToggle.timeFormat(self, false))
    },
    charter () { return this.$store.state.reservation.charter },
    other () { return this.$store.state.other }
  },
  methods: {
    init () {
      let self = this
      let mapContainer = document.getElementById('hereMap')

      self.platform = new window.H.service.Platform({apikey: CONFIG.hereApi.key})

      let defaultLayers = self.platform.createDefaultLayers()
      self.map = new window.H.Map(
        mapContainer,
        defaultLayers.vector.normal.map,
        {
          center: self.center,
          zoom: 13,
          pixelRatio: window.devicePixelRatio || 1
        }
      )

      // add a resize listener to make sure that the map occupies the whole container
      window.addEventListener('resize', () => self.map.getViewPort().resize())

      /* eslint-disable no-unused-vars */
      let behavior = new window.H.mapevents.Behavior(new window.H.mapevents.MapEvents(self.map))
      /* eslint-enable no-unused-vars */
      self.ui = window.H.ui.UI.createDefault(self.map, defaultLayers)

      // Pickup/Dropoff Marker
      let marker = '<svg height="25" width="25" style="overflow: unset" viewBox="0 0 50 50">' +
        '<path d="{D}" fill="{FILL}"stroke="{STROKE}"' +
        'stroke-width="{STROKE_WIDTH}" /></svg>'

      // Add Pickup Pin
      let pickupMarker = marker.replace('{D}', mapPins.pickup.path)
        .replace('{FILL}', mapPins.pickup.fillColor)
        .replace('{STROKE}', mapPins.pickup.strokeColor)
        .replace('{STROKE_WIDTH}', mapPins.pickup.strokeWeight)
      let pickupIcon = new window.H.map.DomIcon(pickupMarker)
      let pickupCoords = {lat: self.rsvp.pickup.lat, lng: self.rsvp.pickup.lng}
      let pickupPin = new window.H.map.DomMarker(
        pickupCoords,
        {icon: pickupIcon}
      )
      let pickupBubble = new window.H.ui.InfoBubble(pickupCoords, {
        content: '<div class="here-info-window-content">' +
          '<div class="label">' + self.$t('rsvpTrack.pickupTime') + '</div>' +
          '<div class="value">' + self.rsvp.pickupTime + '</div>' +
        '</div>'
      })
      self.ui.addBubble(pickupBubble)
      pickupPin.addEventListener('tap', function (evt) {
        pickupBubble.open()
      }, false);
      self.map.addObject(pickupPin)

      if (self.rsvp.extraStops && self.rsvp.extraStops.length) {
        self.rsvp.extraStops.forEach(stop => {
          // Add Stop Pin
          let stopMarker = marker.replace('{D}', mapPins.stop.path)
            .replace('{FILL}', mapPins.stop.fillColor)
            .replace('{STROKE}', mapPins.stop.strokeColor)
            .replace('{STROKE_WIDTH}', mapPins.stop.strokeWeight)
          let stopIcon = new window.H.map.DomIcon(stopMarker)
          let stopCoords = {lat: stop.lat, lng: stop.lng}
          let stopPin = new window.H.map.DomMarker(
            stopCoords,
            {icon: stopIcon}
          )
          self.map.addObject(stopPin)
        })
      }

      // Add DropOff Pin
      if (!self.charter.enabled) {
        let dropoffMarker = marker.replace('{D}', mapPins.dropoff.path)
          .replace('{FILL}', mapPins.dropoff.fillColor)
          .replace('{STROKE}', mapPins.dropoff.strokeColor)
          .replace('{STROKE_WIDTH}', mapPins.dropoff.strokeWeight)
        let dropoffIcon = new window.H.map.DomIcon(dropoffMarker)
        let dropoffCoords = {lat: self.rsvp.dropoff.lat, lng: self.rsvp.dropoff.lng}
        let dropoffPin = new window.H.map.DomMarker(
          dropoffCoords,
          {icon: dropoffIcon}
        )
        let dropoffBubble = new window.H.ui.InfoBubble(dropoffCoords, {
          content: '<div class="here-info-window-content">' +
            '<div class="label">' + self.$t('rsvpTrack.eta') + '</div>' +
            '<div class="value">' + self.eta + '</div>' +
            '</div>'
        })
        self.ui.addBubble(dropoffBubble)
        dropoffPin.addEventListener('tap', function (evt) {
          dropoffBubble.open()
        }, false);
        self.map.addObject(dropoffPin)
        self.calculateRoute(pickupCoords, dropoffCoords, false)
      }

      self.trackDriver()
    },
    calculateRoute (origin, destination, isDriverRoute) {
      let self = this
      // let ifRecorded = self.routeResults.find(x => x.origin.lat === origin.lat && x.origin.lng === origin.lng && x.destination.lat === destination.lat && x.destination.lng === destination.lng)
      // if (ifRecorded) {
      //   self.driverETA = ifRecorded.driverETA
      //   self.addRouteShapeToMap(ifRecorded.route, ifRecorded.isDriverRoute)
      //   return
      // }
      self.lastCoords = {
        origin: origin,
        destination: destination
      }

      if (self.rsvp.hasExtraStop) {
        let url = 'https://router.hereapi.com/v8/routes?apiKey={API_KEY}&origin={ORIGIN}&destination={DESTINATION}&transportMode=car&return=polyline,summary'
        url = url.replace('{ORIGIN}', `${origin.lat},${origin.lng}`)
          .replace('{DESTINATION}', `${destination.lat},${destination.lng}`)
          .replace('{API_KEY}', CONFIG.hereApi.key)
        self.rsvp.extraStops.forEach(stop => {
          url += `&via=${stop.lat},${stop.lng}`
        })
        request.get({
          url: url,
          json: true
        }, function (err, res, body) {
          if (err) {
            self.onError()
            return
          }

          let driverETA = 0
          if (body.routes.length) {
            body.routes[0].sections.forEach(route => {
              driverETA += Math.round(route.summary.duration / 60)
              self.addRouteShapeToMap(route, isDriverRoute)
            })
          }
          self.driverETA = driverETA

          let tmpCopy = JSON.parse(JSON.stringify(self.lastCoords))
          tmpCopy.driverETA = self.driverETA
          tmpCopy.route = body.routes[0].sections[0]
          tmpCopy.isDriverRoute = isDriverRoute
          self.routeResults.push(tmpCopy)
        })
        return
      }
      let router = this.platform.getRoutingService(null, 8)
      let routeRequestParams = {
        routingMode: 'fast',
        transportMode: 'car',
        origin: `${origin.lat},${origin.lng}`,
        destination: `${destination.lat},${destination.lng}`,
        return: 'polyline,turnByTurnActions,actions,instructions,travelSummary'
      }

      router.calculateRoute(
        routeRequestParams,
        this.onSuccess.bind(null, isDriverRoute),
        this.onError
      )
    },
    onSuccess (isDriverRoute, result) {
      if (result.routes.length) {
        var route = result.routes[0].sections[0]
        this.driverETA = Math.round(route.travelSummary.duration / 60)
        this.addRouteShapeToMap(route, isDriverRoute)

        let tmpCopy = JSON.parse(JSON.stringify(this.lastCoords))
        tmpCopy.driverETA = this.driverETA
        tmpCopy.route = route
        tmpCopy.isDriverRoute = isDriverRoute
        this.routeResults.push(tmpCopy)
      }
    },
    onError () {
      alert('Can\'t reach the remote server')
    },
    addRouteShapeToMap (route, isDriverRoute) {
      let linestring = window.H.geo.LineString.fromFlexiblePolyline(route.polyline);
      let polyline = new window.H.map.Polyline(linestring, {
        style: {
          lineWidth: 4,
          strokeColor: isDriverRoute ? '#2EE47D' : 'rgba(25, 25, 25, 0.75)'
        }
      });

      polyline.id = isDriverRoute ? 'driverRoute' : 'rsvpRoute'

      this.map.addObject(polyline)
      this.map.getViewModel().setLookAtData({
        bounds: polyline.getBoundingBox()
      })

      this.setCenter()
    },
    setCenter () {
      let self = this
      let group = new window.H.map.Group()
      // Create object with radius for better bounds
      let pickupCircle = new window.H.map.Circle(
        new window.H.geo.Point(self.rsvp.pickup.lat, self.rsvp.pickup.lng),
        5000,
        {
          style: {
            fillColor: 'rgba(0, 0, 0, 0)',
            strokeColor: 'rgba(0, 0, 0, 0)'
          }
        }
      )
      let dropoffCircle = new window.H.map.Circle(
        new window.H.geo.Point(self.rsvp.dropoff.lat, self.rsvp.dropoff.lng),
        5000,
        {
          style: {
            fillColor: 'rgba(0, 0, 0, 0)',
            strokeColor: 'rgba(0, 0, 0, 0)'
          }
        }
      )

      // Add to group for bounds correction
      group.addObjects([pickupCircle, dropoffCircle])
      group.id = 'groupBound'
      self.map.addObject(group)

      self.map.getViewModel().setLookAtData({
        bounds: group.getBoundingBox()
      })
    },
    trackDriver () {
      let self = this
      if (self.rsvp.provider.ID === null) { return }

      // real-time tracking is only available for on the way reservations
      if (self.rsvp.dispatchStatus !== 'ontheway' && !self.rsvp.isAsap) { return }

      if (self.rsvp.isAsap) {
        self.getLyftDriverLoc()
        return
      }
      self.updateDriverLocation()
    },
    updateDriverLocation () {
      let self = this

      let url = '/reservations/' + self.rsvp.id + '/' + self.rsvp.consumer.firstName + '/' + self.rsvp.consumer.lastName + '/driver'
      self.$sdk.get(self, url, {}, r => {
        self.driverPath(r)
        self.driverTimer = setTimeout(function () {
          self.updateDriverLocation()
        }, self.other.hereMapsRouteDelay * 1000)
      })
    },
    resetAll () {
      if (this.driverTimer) clearTimeout(this.driverTimer)
    },
    getLyftDriverLoc () {
      let self = this
      let url = `/reservations/${self.rsvp.id}/${self.rsvp.consumer.firstName}/${self.rsvp.consumer.lastName}/asaptrack`
      self.$sdk.get(self, url, {}, r => {
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message.replace('backend.', '')
          })
          return
        }

        if (['droppedOff', 'canceled'].indexOf(r.status) > -1) {
          let msg = self.$t('searchTrack.rsvpCompleted')
          if (['canceled', 'cancelled'].indexOf(r.status) > -1) msg = self.$t('searchTrack.rsvpCancelled')
          self.$store.commit('global/setAlertData', {
            show: true,
            message: msg
          })
          self.$root.$router.push('search')
          return
        }
        if (r.tracking === null) {
          self.chkStatus()
          return
        }

        if (r.status === 'pickedUp') self.userPickedUp = true
        self.$store.commit('rsvpTrack/updateLyftStatus', r.status)

        self.driverPath({list: [r.tracking]})
        if (self.$route.name !== 'RsvpTrack') {
          self.resetAll()
          return
        }
        self.driverTimer = setTimeout(function () {
          self.getLyftDriverLoc()
        }, self.other.hereMapsRouteDelay * 1000)
      })

      if (self.asapDirectMapFix) {
        self.asapDirectMapFix = false
        setTimeout(() => {
          self.map.getViewPort().resize()
          self.setCenter()
          window.dispatchEvent(new Event('resize'))
        }, 1000)
      }
    },
    driverPath (r) {
      let self = this
      if (r.list && r.list.length > 0) {
        // clear current car and car route
        for (let object of self.map.getObjects()) {
          // if (object.id === 'driverRoute' || (object.icon && object.icon.f && object.icon.f.id === 'H_car_icon') ||
          if (object.id === 'driverRoute' || (object.icon) ||
            object.id === 'groupBound'
          ) {
            self.map.removeObject(object);
          }
        }

        self.ui.getBubbles().forEach(bub => {
          if (bub.id === 'driverBubble') {
            self.ui.removeBubble(bub)
          }
        })

        let marker = '<div id="H_car_icon"><svg height="25" width="25" style="overflow: overlay" viewBox="0 0 50 50">' +
          '<path d="{D}" fill="{FILL}"stroke="{STROKE}"' +
          'stroke-width="{STROKE_WIDTH}" /></svg></div>'
        if ('bearing' in r.list[0]) {
          marker = `<div class="sprite-car-box">
            <div class="sprite-car" style="background-position:${Math.round(r.list[0].bearing) * 60}px"></div>
          </div>`
        }

        let carMarker = marker.replace('{D}', mapPins.car.path)
          .replace('{FILL}', mapPins.car.fillColor)
          .replace('{STROKE}', mapPins.car.strokeColor)
          .replace('{STROKE_WIDTH}', mapPins.car.strokeWeight)
        let carIcon = new window.H.map.DomIcon(carMarker)
        let carCoords = {lat: r.list[0].lat, lng: r.list[0].lng}
        let carPin = new window.H.map.DomMarker(
          carCoords,
          {icon: carIcon}
        )

        let provider = self.$store.state.rsvpTrack.rsvp.provider
        if (provider.ID) {
          let carBubble = new window.H.ui.InfoBubble(carCoords, {
            content: '<div class="here-info-window-content">' +
              '<div class="label">' + provider.firstName + ' is ' + self.driverETA + ' minutes away:</div>' +
            '</div>'
          })
          carBubble.id = 'driverBubble'
          self.ui.addBubble(carBubble)
          carBubble.addEventListener('tap', function (evt) {
            carBubble.open()
          }, false);
        }
        self.map.addObject(carPin)

        let pickupCoords = {lat: self.rsvp.pickup.lat, lng: self.rsvp.pickup.lng}
        if (self.rsvp.dispatchStatus !== 'ontheway' || self.userPickedUp) {
          pickupCoords = {lat: self.rsvp.dropoff.lat, lng: self.rsvp.dropoff.lng}
        }
        self.calculateRoute(carCoords, pickupCoords, true)
      }
    },
    chkStatus () {
      let self = this
      ApiRsvpSearch.search(self, self.rsvp.id, self.rsvp.consumer.firstName, self.rsvp.consumer.lastName, rsvp => {
        let msg = ''
        if (rsvp.isMtech) msg = 'Tracking is not available for this reservation.'
        if (rsvp.dispatchStatus === 'complete') msg = self.$t('searchTrack.rsvpCompleted')
        if (rsvp.dispatchStatus === 'canceled') msg = self.$t('searchTrack.rsvpCancelled')
        if (msg) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: msg
          })
          self.$root.$router.push('search')
          return
        }
      })
    }
  },
  mounted () {
    if (this.$store.state.global.asapSuccess.show) {
      this.asapDirectMapFix = true
    }

    this.userPickedUp = false
    this.resetAll()
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.map{
  height: 500px;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// Map2.vue?c16e310e